module.exports = __webpack_public_path__ + "ba88287cf2e551abdf2d252c3142253c.png";